module.exports = __webpack_public_path__ + "img/phone-call.c9f95262.svg";